import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PreloaderModule } from '../preloader/preloader.module';
import { IconModule } from '../icon/icon.module';
import { DownloadItemComponent } from './download-item.component';


@NgModule({
  imports: [
    CommonModule,
    PreloaderModule,
    IconModule,
  ],
  declarations: [
    DownloadItemComponent,
  ],
  exports: [
    DownloadItemComponent,
   ],
  providers: []
})
export class DownloadItemModule {}
